/** @flow */

import {
  GetAlertsList,
  GetAlertsListSuccess,
  GetAlertsListError,
  GetAlert,
  GetAlertSuccess,
  GetAlertError,
  GetAlertSchema,
  GetAlertSchemaSuccess,
  GetAlertSchemaError,
  NewAlert,
  StartDraftAlertSuccess,
  SetAlertDraft,
  NewAlertAssignments,
  SetAlertAssignments,
  SetShowAddAlertRecipientModal,
  SetShowAddAlertAttachmentModal,
  SetShowDeleteAlertAttachmentModal,
  SetAlertDraftAssignments,
  AddAlert,
  AddAlertSuccess,
  UpdateAlert,
  UpdateAlertSuccess,
  UpdateAlertError,
  DisableAlert,
  DisableAlertSuccess,
  DisableAlertError,
  ResetAlertsState,
} from "@modules/service/constants/actions";
import * as alertsReducers from "./reducers";
import initialState from "./state";
import type { AlertsState } from "./types";
import { cloneObject } from "@utils/object";

export default (state: AlertsState = initialState, action: Object): AlertsState => {
  const act = {
    [DisableAlert]: alertsReducers.onDisableAlert,
    [DisableAlertSuccess]: alertsReducers.onDisableAlertSuccess,
    [DisableAlertError]: alertsReducers.onDisableAlertError,

    [UpdateAlert]: alertsReducers.onUpdateAlert,
    [UpdateAlertSuccess]: alertsReducers.onUpdateAlertSuccess,
    [UpdateAlertError]: alertsReducers.onUpdateAlertError,
    [AddAlert]: alertsReducers.onAddAlert,
    [AddAlertSuccess]: alertsReducers.onAddAlertSuccess,
    [GetAlertsList]: alertsReducers.onGetAlertsList,
    [GetAlertsListSuccess]: alertsReducers.onGetAlertsListSuccess,
    [GetAlertsListError]: alertsReducers.onGetAlertsListError,

    [GetAlert]: alertsReducers.onGetAlert,
    [GetAlertSuccess]: alertsReducers.onGetAlertSuccess,
    [GetAlertError]: alertsReducers.onGetAlertError,

    [GetAlertSchema]: alertsReducers.onGetSchema,
    [GetAlertSchemaSuccess]: alertsReducers.onGetSchemaSuccess,
    [GetAlertSchemaError]: alertsReducers.onGetSchemaError,

    [NewAlert]: alertsReducers.onNew,
    [StartDraftAlertSuccess]: alertsReducers.onStartDraftSuccess,
    [SetAlertDraft]: alertsReducers.onSetDraft,

    [NewAlertAssignments]: alertsReducers.onNewAssignments,
    [SetAlertAssignments]: alertsReducers.onSetAssignments,
    [SetAlertDraftAssignments]: alertsReducers.onSetAlertDraftAssignments,

    [SetShowAddAlertRecipientModal]: alertsReducers.onSetShowAddAlertRecipientModal,

    [SetShowAddAlertAttachmentModal]: alertsReducers.onSetShowAddAlertAttachmentModal,

    [SetShowDeleteAlertAttachmentModal]: alertsReducers.onSetShowDeleteAlertAttachmentModal,
    [ResetAlertsState]: alertsReducers.onResetAlertsState,
  };

  if (action && action.type && act && act[action.type]) {
    return act[action.type](cloneObject(state))(action);
  }
  return state;
};
